<template>
  <b-row no-gutters class="h-100 template-one">
    <b-col
      cols="12"
      sm="6"
      xl="8"
      class="p-5 d-none d-sm-flex justify-content-center align-items-center background-container"
      :style="{ backgroundImage: 'url(' + backgroundImage + ')' }"
    ></b-col>
    <b-col
      cols="12"
      sm="6"
      xl="4"
      class="bg-light p-5 d-flex flex-column justify-content-center align-items-center shadow-lg"
    >
      <div class="text-center my-auto">
        <img :src="logo" alt="logo" class="img-fluid mx-auto mb-4" />
        <div class="disclaimer-first-wrapper mb-3">
          <TechText
            :text="disclaimerFirst"
            :font-weight="600"
            :font-size="150"
            :letter-spacing="-0.02"
            :speed="0.5"
          />
        </div>
        <div class="disclaimer font-weight-light">{{ disclaimerSecond }}</div>
      </div>
      <div class="mt-auto text-center social-media-container">
        <a
          v-if="linkedin"
          :href="linkedin"
          target="_blank"
          class="text-body mx-2 my-3"
          >LinkedIn</a
        >
      </div>
    </b-col>
  </b-row>
</template>

<script>
import TechText from "./TechText.vue";

export default {
  name: "TemplateOne",
  components: { TechText },
  data() {
    return {
      logo: require("@/assets/logo.png"),
      backgroundImage: require("@/assets/bg.jpg"),
      disclaimerFirst: process.env.VUE_APP_DISCLAIMER_FIRST_LINE,
      disclaimerSecond: process.env.VUE_APP_DISCLAIMER_SECOND_LINE,
      linkedin: process.env.VUE_APP_LINKEDIN,
    };
  },
};
</script>

<style lang="scss" scoped>
.template-one {
  .disclaimer-first-wrapper {
    width: 100%;
    height: 180px;
  }
  .disclaimer {
    font-size: 1.5rem;
  }
  .background-container {
    background-position: center center;
    background-size: cover;
    box-shadow: inset 0rem 0rem 5rem rgba(0, 0, 0, 0.2) !important;
  }
  .social-media-container {
    a {
      transition: all 1s;
      &:hover {
        color: gray !important;
        text-decoration: none;
      }
    }
  }
}
</style>
